module.exports = __webpack_public_path__ + "img/WorshipConf.853621eb.jpg";